import { makeProgram } from '../cli.js'

makeProgram().parse()
